import { RESET_VIEW_GLOBAL } from 'store/global/actionType';
export const SET_VIEW_NAME = 'SET_VIEW_NAME';
export const RESET_VIEW = RESET_VIEW_GLOBAL;


// WEBPACK FOOTER //
// ./src/components/page/ObjectFilter/components/ViewName/flow/actionTypes.js